module.exports = __webpack_public_path__ + "img/canvasMenuLine.faa6a025.svg";